import React from "react";
import "./assets/styles/responsive.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import VerifyOTP from "./pages/verifyOTP";

import DashboardLayout from "./components/layout/AdminLayout";
import StudentLayout from "./components/layout/StudentLayout";

/* PUBLIC PAGES */
import Home from "./pages/Home";
import Register from "./pages/Register";
import RegisterSuccess from "./pages/RegisterSuccess";
import AdminLogin from "./pages/Admin/AdminLogin";
import StudentLogin from "./pages/Students/StudentLogin";
import PayFees from "./pages/Students/PayFees";

/* ADMIN PAGES */
import AdminDashboard from "./pages/Admin/AdminDashboard";
import Students from "./pages/Students";
import Attendance from "./pages/Admin/Attendance";
import Payments from "./pages/Admin/Payments";
import AdminStudentProfile from "./pages/Admin/AdminStudentProfile";

/* STUDENT PANEL */
import StudentDashboard from "./pages/Students/StudentDashboard";
import StudentAttendance from "./pages/Students/StudentAttendance";
import StudentPayments from "./pages/Students/StudentPayment";
import StudentProfile from "./pages/Students/StudentProfile";

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* PUBLIC ROUTES */}
          <Route path="/" element={<Home />} />
          <Route path="/admin-login" element={<AdminLogin />} />
          <Route path="/student-login" element={<StudentLogin />} />
          <Route path="/register" element={<Register />} />
          <Route path="/register-success" element={<RegisterSuccess />} />
          <Route path="/pay-fees" element={<PayFees />} />

          {/* ADMIN PANEL */}
          <Route
            path="/dashboard"
            element={
              <DashboardLayout>
                <AdminDashboard />
              </DashboardLayout>
            }
          />

          <Route
            path="/students"
            element={
              <DashboardLayout>
                <Students />
              </DashboardLayout>
            }
          />

          <Route
            path="/students/:id"
            element={
              <DashboardLayout>
                <AdminStudentProfile />
              </DashboardLayout>
            }
          />

          <Route
            path="/attendance"
            element={
              <DashboardLayout>
                <Attendance />
              </DashboardLayout>
            }
          />

          <Route
            path="/payments"
            element={
              <DashboardLayout>
                <Payments />
              </DashboardLayout>
            }
          />

          {/* STUDENT PANEL */}

          <Route
            path="/student-dashboard"
            element={
              <StudentLayout>
                <StudentDashboard />
              </StudentLayout>
            }
          />

          <Route
            path="/student-attendance"
            element={
              <StudentLayout>
                <StudentAttendance />
              </StudentLayout>
            }
          />

          <Route
            path="/student-payments"
            element={
              <StudentLayout>
                <StudentPayments />
              </StudentLayout>
            }
          />

          <Route path="/verify-otp" element={<VerifyOTP />} />
          <Route
            path="/student-profile"
            element={
              <StudentLayout>
                <StudentProfile />
              </StudentLayout>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
